import Vue from 'vue'
import Loader from '../components/Loader.vue'

const LoaderConstructor = Vue.extend(Loader)
let instance

export default {
    install() {
        const api = {
            show() {
                if (!instance) {
                    instance = new LoaderConstructor({ propsData: { value: true } })
                    instance.$mount()
                    document.body.appendChild(instance.$el)
                } else {
                    instance.value = true
                }
            },
            hide() {
                if (instance) instance.value = false
            }
        }

        // dispoe global e em instâncias
        Vue.$loader = api
        Vue.prototype.$loader = api
    }
}
